import React from 'react';
import './style.scss';
import { ReactComponent as YellowTriangle } from './../../../../images/yellow-triangle.svg';

interface AlarmProps {
  value: string;
}

const Alarm: React.FC<AlarmProps> = ({ value }) => {
  return (
    <div className='alarm-cell'>
      <div className='alarm-cell-content'>
        <YellowTriangle className='alarm-cell-bg' />
        <div className='alarm-cell-value'>{value}</div>
      </div>
    </div>
  );
};
export default Alarm;
